module.exports = __webpack_public_path__ + "img/cloud-wind-2-sun.888edbde.svg";